

var lat = "";
var lon = "";
var markerImage = "";
var visibleLayers = "";
var excludedLayers = "";
var frameName = "";

function obliqueImagery(options) {
  this.options = options;
}

obliqueImagery.prototype.addEnterObliqueFullscreenEventListener = function () {
  var div = document.createElement('div');
  div.setAttribute('id', 'obliqueImageryFullscreenBtn');
  div.setAttribute('role', 'button');
  div.setAttribute('tabindex', '0');
  div.setAttribute('alt', 'Enter full screen');
  div.setAttribute("title", "Enter full screen");
  div.className = "obliqueImagery-full-screen-button full-screen-img fade-full-screen";
  document.getElementById('obliqueImagery').appendChild(div).after;
  $('.obliqueImagery-full-screen-button').on('click', {
    name: frameName
  }, obliqueImagery.prototype.enterObliqueFullScreen);
};

function escFunction(event) {
  if (event.key == 'Escape') {
    if (obliqueImagery.prototype.isFullscreen()) {
      obliqueImagery.prototype.exitObliqueFullscreen();
    }
  }
}

obliqueImagery.prototype.isFullscreen = function () {
  var btn = document.getElementById('obliqueImageryFullscreenBtn');

  if (btn) {
    return btn.classList.contains("active");
  }

  return false;
};

obliqueImagery.prototype.enterObliqueFullScreen = function () {
  try {
    if (obliqueImagery.prototype.isFullscreen()) {
      obliqueImagery.prototype.exitObliqueFullscreen();
    } else {
      document.addEventListener("keydown", escFunction);
      document.getElementById('container').classList.add('d-none');
      document.getElementById('ZoneA').classList.add('d-none');
      document.getElementById('ZoneB').classList.add('d-none');
      document.getElementById('ZoneC').classList.add('d-none');
      var fragment = document.createDocumentFragment();
      var element = document.getElementById("pictometry_ipa_container");
      var btn = document.getElementById('obliqueImageryFullscreenBtn');

      if (btn) {
        btn.setAttribute('style', 'top: 6px;');
        btn.classList.add('active');
        element.appendChild(btn).after;
      }

      var p = document.getElementById('pictometry_ipa');
      p.classList.add('pictometry-ipa');
      element.setAttribute("class", "obliqueImagery-viewer-full");
      fragment.appendChild(element);
      document.body.appendChild(fragment);
    }
  } catch (error) {
    console.log(error);
  }
};

obliqueImagery.prototype.exitObliqueFullscreen = function () {
  try {
    document.removeEventListener("keydown", escFunction);
    var ipa = obliqueImagery.prototype.obliqueReference;

    try {
      ipa.deactivateDualPane();
    } catch (error) {}

    var p = document.getElementById('pictometry_ipa');
    document.removeEventListener("keydown", escFunction);
    p.classList.remove('pictometry-ipa');
    var element = document.getElementById("pictometry_ipa_container");
    element.setAttribute("class", "obliqueImagery-viewer-small");
    document.getElementById('obliqueImagery').appendChild(element);
    var btn = document.getElementById('obliqueImageryFullscreenBtn');

    if (btn) {
      btn.setAttribute('style', 'top: 4px;');
      btn.classList.remove('active');
    }

    document.getElementById('container').classList.remove('d-none');
    document.getElementById('ZoneA').classList.remove('d-none');
    document.getElementById('ZoneB').classList.remove('d-none');
    document.getElementById('ZoneC').classList.remove('d-none');
  } catch (error) {
    console.log(error);
  }
};

obliqueImagery.prototype.obliqueReference = function () {};

obliqueImagery.prototype.obliqueImageryHandler = function (ipa) {
  lat = this.options.lat;
  lon = this.options.lon;
  markerImage = this.options.markerImage;
  visibleLayers = this.options.visibleLayers;
  excludedLayers = this.options.excludedLayers;
  frameName = this.options.frameName;

  try {




    ipa.showDashboard({
      dualPane: obliqueImagery.prototype.isFullscreen()
    });

        ipa.setPreferences({
      showStreetLayer: false,
      searchHighlightWeight: 20
    });  

        ipa.getLayers(function (layers) {
      if (layers.layers.length > 0) {
        layers.layers.forEach(function (id) {
          ipa.showLayer({
            id: id,
            visible: false
          });
        }); 

                visibleLayers.forEach(function (id) {
          ipa.showLayer({
            id: id,
            visible: true
          });
        }); 

        for (var i = 0; i < layers.layers.length; i++) {
          var layer = layers.layers[i];

          if (excludedLayers.includes(layer.id)) {
            var config = {};
            config.layerId = layer.id;
            config.show = false;
            ipa.configureLayersMenu([config]);
          } 
        } 
      } 
    }); 

        ipa.setLocation({
      y: lat,
      x: lon,
      zoom: 20
    }); 

    var marker = {
      type: ipa.SHAPE_TYPE.MARKER,
      center: {
        y: lat,
        x: lon
      },
      markerImageHeight: 26,
      markerImageWidth: 26,
      markerOffsetX: 5,
      markerOffsetY: -20,
      markerImage: markerImage,
      onShapeClick: true
    }; 

        var shapeIds = [];
    ipa.addShapes([marker], function (result) {
      for (var i = 0; i < result.length; i++) {
        if (result[i].success === false) {
          alert(result[i].error);
        } else {
          shapeIds.push(result[i].shapeId);
        }
      } 
    }); 

    obliqueImagery.prototype.obliqueReference = ipa;
  } catch (error) {
    console.log(error);
  } 
}; 